/**
 * @desc 查询Details
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.IdParameter): Promise<BaseResponse<defs.ResultBean<defs.Details>>> {
  return fetch({
    url: config.API_HOST + '/base/resPublishInfo/findById',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
